import { BOOKED_SLOT } from "shared/consts";
import styled from "styled-components";

export const Order = styled.div`
  background-color: #fff;
  border-radius: 12px;
  padding: 8px 12px;
  display: grid;
  grid-template-columns: 40px auto 46px;
  gap: 2px 10px;
  align-items: center;
  cursor: pointer;
  button {
    grid-column-start: 3;
    grid-row-start: 1;
    grid-row: span 2;
  }
`

type CircleProps = {
  $bgc?: string
}
export const Circle = styled.div<CircleProps>`
  grid-row: span 2;
  aspect-ratio: 1;
  display: flex;
  justify-content:center;align-items: center;
  border-radius: 50%;
  color: #fff;
  background-color: ${props => props.$bgc || BOOKED_SLOT};
  font-weight: 600;
  font-size: 18px;
  line-height: 1.2;
`;

export const Name = styled.div`
  grid-row-start: 1;
  grid-column-start: 2;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.2;
`;

export const Time = styled.div`
  font-size: 16px;
  line-height: 1.2;
  grid-row-start: 2;
  grid-column-start: 2;
`;